export const USER_TYPE = 'Internal Quality Assessor'
export const BROWSER_STORAGE_KEYS = {
  auth: 'auth',
  tempDeviceId: 'tempDeviceId',
}

export const DEFAULT_PAGE_SIZE = 10
export const refresh_token_url = '/solis/v1/auth/refresh-token/'

export const SUBMISSION_STATUS_CHOICES = {
  PENDING: 1,
  CHALLENGED: 2,
  AWAITING_RESPONSE: 3,
  ACCEPTED: 4,
  REJECTED: 5,
}

// Review Evaluation
export const REVIEW_EVALUATION_STATUS_CHOICES = {
  // TODO: Remove this
  // Only for frontend
  NOT_STARTED: null,

  UNDER_EVALUATION: 0,
  CHANGES_REQUESTED: 1,
  CHALLENGED: 2,
  ACCEPTED: 3,
  REVIEW_CHANGED: 4,
}

export const REVIEW_STATUS = {
  UNDER_REVIEW: 'under_review',
  NOT_REVIEWED: 'not_reviewed',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  PLAGIARISED: 'plagiarised',
}

// Assignment User
export const EVALUATION_STATUS = {
  UNDER_EVALUATION: 0,
  CHANGES_REQUESTED: 1,
  CHALLENGED: 2,
  COMPLETED: 3,
  SKIPPED: 4,
}

export const USER_COURSE_QA = {
  NOT_STARTED: null,
  UNDER_QA: 0,
  COMPLETED: 1,
}

export const EVALUATION_VIEW_TYPE_CHOICES = {
  BY_STUDENT: 1,
  BY_PROFESSOR: 2,
}
